module.exports = __webpack_public_path__ + "img/logo-header-white.f5b1043b.png";